import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
  Store,
  Order,
  OrderItem,
  OrderingState,
  SubmitOrderState,
  PaymentInfo,
} from 'models'
import { TableInfo } from 'models/TableInfo'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const initialState: OrderingState = {
  isCartVisible: false,
  isCartButtonVisible: false,
  isEditOrderDialogVisible: false,
  isContinueAsGuest: false,

  submitOrderState: {
    isSubmitting: false,
    isError: false,
    isSuccess: false,
    error: undefined,
    result: undefined,
  },
}

const slice = createSlice({
  name: 'ordering',
  initialState,
  reducers: {
    setStore: (state, { payload: store }: PayloadAction<Store | undefined>) => {
      state.store = store
    },
    setOrder: (state, { payload: order }: PayloadAction<Order | undefined>) => {
      state.order = order
    },
    setCartVisible: (state, { payload: visible }: PayloadAction<boolean>) => {
      state.isCartVisible = visible
    },
    setCartButtonVisible: (state, { payload }: PayloadAction<boolean>) => {
      state.isCartButtonVisible = payload
    },
    setEditingOrderItem: (
      state,
      { payload }: PayloadAction<OrderItem | undefined>,
    ) => {
      state.editingOrderItem = payload
    },
    setEditOrderDialogVisible: (state, { payload }: PayloadAction<boolean>) => {
      state.isEditOrderDialogVisible = payload
    },
    setSubmitOrderState: (
      state,
      { payload }: PayloadAction<SubmitOrderState>,
    ) => {
      state.submitOrderState = payload
    },
    setTableInfo: (
      state,
      { payload }: PayloadAction<TableInfo | undefined>,
    ) => {
      state.tableInfo = payload
    },
    setContinueAsGuest: (state, { payload }: PayloadAction<boolean>) => {
      state.isContinueAsGuest = payload
    },
    clearTableAndOrderData: (state) => {
      state.tableInfo = undefined
      state.order = undefined
    },
    saveCardToOrder: (state, { payload }: PayloadAction<PaymentInfo>) => {
      if (state.order) {
        state.order.card = payload
      }
    },
  },
})

export const {
  setStore,
  setOrder,
  setCartVisible,
  setCartButtonVisible,
  setEditingOrderItem,
  setEditOrderDialogVisible,
  setSubmitOrderState,
  setTableInfo,
  setContinueAsGuest,
  clearTableAndOrderData,
  saveCardToOrder,
} = slice.actions

export const orderingReducer = persistReducer(
  { key: 'ordering', storage },
  slice.reducer,
)
